export interface Transaction {
    id: number;
    fileNumber: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    status: TransactionStatus;
    createdDate: Date;
    providerReferenceId?: string;
    phoneNumberProvided: boolean;
}

export enum TransactionStatus {
    Pending = 1,
    Completed = 2,
    Failed = 3,
    Expired = 4,
}

export interface PaginatedResponse<T> {
    pageIndex: number;
    pageSize: number;
    count: number;
    data: T[];
}

export interface TranscationQuery {
    searchTerm?: string;
    statuses?: TransactionStatus[];
}